import { render, staticRenderFns } from "./bar-Grouped.vue?vue&type=template&id=2470e32f&"
import script from "./bar-Grouped.vue?vue&type=script&lang=js&"
export * from "./bar-Grouped.vue?vue&type=script&lang=js&"
import style0 from "./bar-Grouped.vue?vue&type=style&index=0&id=2470e32f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports